import styled from 'styled-components';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import Pagination from '../../components/pagination/Pagination';
import { useSearchParams } from 'react-router-dom';
import { ThemeData } from '../quantData';
import QuantService from '../../../service/quant/Quant';
import { useModal } from '../../../context/ModalContext';
import ReportModal from './ReportModal';
import ThemeModal from '../../mypage/quant/ThemeModal';
import { isFinalMonth } from '../../../utils/auth';
import DetailInfoModal from './DetailInfoModal';
import ViewCountModal from './ViewCountModal';
import SortOptionModal from './SortOptionModal';
import { useQuantContext } from '../../../context/QuantContext';
import QuotaService from '../../../service/quota/Quota';
import { useUser } from '../../../context/UserContext';
export interface QuantReportItem {
  roi: string;
  roe: string;
  region: string;
  category: string;
  tags: Array<string>;
  type: number;
  iidx: string;
  quant_idx: string;
  ex_bid_prc: string;
  ex_sale_prc: string;
  margin: string;
  status: string;
  is_possible: number;
  appraisal_vs_market_price: string;
  bid_vs_public_land_price: string;
  lowest_bid_vs_jeonse: string;
  jeonse_advantage_3y: string;
  wolse_advantage_3y: string;
  nearby_avg_vs_market_price: string;
  sale_price_vs_lowest_bid: string;
  expected_equity: string;
  real_trade_growth_rate_1y: string;
  monthly_rent_vs_loan_interest: string;
  appraise_prc: number;
  min_prc: number;
  official_prc: number;
  jeonse: number;
  surrounding_prc: number;
  investment: number;
  wolse_interest: number | null;
  wolse_profit: number | null;
}

const Quant3 = () => {
  const { user } = useUser();
  const { modalDispatch } = useModal();

  const [list, setList] = useState<
    Array<{
      roi: string;
      roe: string;
      region: string;
      category: string;
      tags: Array<string>;
      type: number;
      iidx: string;
      quant_idx: string;
      ex_bid_prc: string;
      ex_sale_prc: string;
      margin: string;
      status: string;
      is_possible: number;
      appraisal_vs_market_price: string;
      bid_vs_public_land_price: string;
      lowest_bid_vs_jeonse: string;
      jeonse_advantage_3y: string;
      wolse_advantage_3y: string;
      nearby_avg_vs_market_price: string;
      sale_price_vs_lowest_bid: string;
      expected_equity: string;
      real_trade_growth_rate_1y: string;
      monthly_rent_vs_loan_interest: string;
      appraise_prc: number; // 감정가
      min_prc: number; // 최저입찰가
      official_prc: number; // 공시지가
      jeonse: number; // 전세보증금
      surrounding_prc: number; // 인근평균시세
      investment: number; // 예상 자기자본
      wolse_profit: number | null; // 월세수익
      wolse_interest: number | null; // 월 대출이자
    }>
  >([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const index = Number(searchParams.get('index'));
  const index_item = Number(searchParams.get('indexes'));
  const { selectedRegions, selectedCategory, setNoItem } = useQuantContext();

  // const selectedRegion = searchParams.get('region');
  // const selectedCategory = searchParams.get('category');
  const item = ThemeData[index as number];
  const [selectedIdx, setselectedIdx] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<string[]>([]);
  const [openViewCountModal, setOpenViewCountModal] = useState(false);
  const [oepnSortOptionModal, setOepnSortOptionModal] = useState(false);

  const [limit, setLimit] = useState(9);
  const [sort, setSort] = useState('AA');

  const sortLabelMap: Record<string, string> = {
    AA: '예상입찰가 낮은순',
    AD: '예상입찰가 높은순',

    BA: '예상매각가 낮은순',
    BD: '예상매각가 높은순',

    CA: '매매차익 낮은순',
    CD: '매매차익 높은순',

    DA: '유찰횟수 적은순',
    DD: '유찰횟수 많은순',

    EA: 'ROI 낮은순',
    ED: 'ROI 높은순',

    FA: 'ROE 낮은순',
    FD: 'ROE 높은순',
  };

  const indexes = useMemo(() => {
    return searchParams.get('indexes')?.split(',').map(Number) || [];
  }, [searchParams]);

  const selectedThemes = useMemo(() => {
    return indexes.map((idx) => ThemeData[idx]).filter(Boolean);
  }, [indexes]);

  const [cuurentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [openDetailInfoModal, setOpenDetailInfoModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<QuantReportItem | null>(
    null,
  );
  const getCode = (region: string) => {
    const regObj = {
      전국: '',
      서울: '11',
      경기: '41',
      인천: '28',
      부산: '26',
      대전: '30',
      대구: '27',
      울산: '31',
      세종: '36',
      강원: '51',
      충북: '43',
      충남: '44',
      경북: '47',
      경남: '48',
      광주: '29',
      전북: '52',
      전남: '46',
      제주: '50',
    };
    return regObj[region as '전국'];
  };

  const themeMap: Record<string, keyof (typeof list)[0]> = {
    저평가주: 'appraisal_vs_market_price',
    공시지가보다낮주: 'bid_vs_public_land_price',
    전세가보다낮주: 'lowest_bid_vs_jeonse',
    전세우위주: 'jeonse_advantage_3y',
    월세우위주: 'wolse_advantage_3y',
    평균보다낮주: 'nearby_avg_vs_market_price',
    시세차익주: 'sale_price_vs_lowest_bid',
    저평가부실채권주: 'appraisal_vs_market_price',
    소액투자주: 'expected_equity',
    시세상승주: 'real_trade_growth_rate_1y',
    이자보다월세주: 'monthly_rent_vs_loan_interest',
  };

  const boldWords = [
    '감정가',
    '입찰가',
    '최저입찰가',
    '전세 우위',
    '월세 우위',
    '시세',
    '매각가',
    '자기자본',
    '실거래 상승율',
    '월세 수익률',
  ];

  const renderDetailTitle = (fullText: string) => {
    const boldWord = boldWords.find((word) => fullText.includes(word));

    if (!boldWord) return fullText;

    const parts = fullText.split(boldWord);

    return (
      <>
        {parts[0]} <span>{boldWord}</span> {parts[1]}
      </>
    );
  };

  const getList = async () => {
    try {
      const themeNames = selectedThemes.map((t) => t.name).join(',');
      if (indexes.length === 0) {
        return;
      }
      const regions = selectedRegions.map((r) => getCode(r)).join(',');

      const result = await QuantService.list({
        theme: themeNames,
        category: selectedCategory.join(','),
        ctpCode: regions,
        sort: sort,
        limit: limit,
        offset: (cuurentPage - 1) * limit,
      });
      if (result.data) {
        setTotalCount(result.data.totalCount);
        setList(
          result.data.list.map((el: any) => {
            let tags = [];
            let type = 0;
            if (el.roi < 5 && el.roe < 7) {
              tags.push('안정형');
              type = 1;
            } else if (el.roi >= 5 && el.roi < 7 && el.roe >= 6 && el.roe < 9) {
              tags.push('안정추구형');
              type = 2;
            } else if (
              el.roi >= 7 &&
              el.roi < 10 &&
              el.roe >= 8 &&
              el.roe < 12
            ) {
              tags.push('위험중립형');
              type = 3;
            } else if (
              el.roi >= 10 &&
              el.roi < 15 &&
              el.roe >= 12 &&
              el.roe < 20
            ) {
              tags.push('적극투자형');
              type = 4;
            } else if (el.roi >= 15 && el.roe >= 20) {
              tags.push('공격투자형');
              type = 5;
            }

            tags.push(el.status);

            tags.push(Math.ceil(el.pyeong / 10) * 10 + '평 이하');
            if (el.years) {
              tags.push('노후 ' + Math.ceil(el.years / 10) * 10 + '년 이하');
            }

            return {
              idx: el.quant_idx,
              region: el.region,
              roi: el.roi,
              roe: el.roe,
              category: el.category,
              tags: tags,
              iidx: el.iidx,
              type,
              quant_idx: el.quant_idx,
              ex_bid_prc: el.ex_bid_prc,
              ex_sale_prc: el.ex_sale_prc,
              margin: el.margin,
              status: el.status,
              is_possible: el.is_possible,
              appraisal_vs_market_price: el.appraisal_vs_market_price,
              bid_vs_public_land_price: el.bid_vs_public_land_price,
              lowest_bid_vs_jeonse: el.lowest_bid_vs_jeonse,
              jeonse_advantage_3y: el.jeonse_advantage_3y,
              wolse_advantage_3y: el.wolse_advantage_3y,
              nearby_avg_vs_market_price: el.nearby_avg_vs_market_price,
              sale_price_vs_lowest_bid: el.sale_price_vs_lowest_bid,
              expected_equity: el.expected_equity,
              real_trade_growth_rate_1y: el.real_trade_growth_rate_1y,
              monthly_rent_vs_loan_interest: el.monthly_rent_vs_loan_interest,
              appraise_prc: el.appraise_prc,
              min_prc: el.min_prc,
              official_prc: el.official_prc,
              jeonse: el.jeonse,
              surrounding_prc: el.surrounding_prc,
              investment: el.investment,
              wolse_profit: el.wolse_profit ?? null,
              wolse_interest: el.wolse_interest ?? null,
            };
          }),
        );
        if (result.data.list.length === 0) {
          setNoItem(true);
        } else {
          setNoItem(false);
        }
      }
      console.log(result);
    } catch (err) {
      console.log(err);
    }
  };
  const func = async () => {
    getList();
    // if (await UserService.userGrade()) {
    // } else {
    //   modalDispatch({ type: 'MC1' });
    // }
  };

  function formatKoreanWon(amount: number | string) {
    if (typeof amount === 'string') {
      amount = parseFloat(amount.replace(/,/g, ''));
    }

    if (typeof amount !== 'number' || isNaN(amount)) return '-';

    const units = [
      { value: 100000000, label: '억 ' },
      { value: 10000, label: '만' },
    ];

    let result = '';
    for (let unit of units) {
      if (amount >= unit.value) {
        const unitCount = Math.floor(amount / unit.value);
        amount %= unit.value;
        result += unitCount + unit.label;
      }
    }

    // 1만 미만인 경우 그냥 숫자 그대로 보여주기
    if (result === '') {
      result = amount.toLocaleString() + '원';
    }

    return result;
  }

  useEffect(() => {
    if (cuurentPage === 1) {
      func();
    } else {
      setCurrentPage(1);
    }
  }, [selectedRegions, selectedCategory, selectedThemes, sort]);

  useEffect(() => {
    func();
  }, [cuurentPage]);

  const [quotaAccess, setQuotaAccess] = useState(false);
  const [count, setCount] = useState(0);
  const [userLimit, setUserLimit] = useState(0);

  const getValue = (list: any[]) => {
    const f = list.find((x) => x.type === 'B');
    return { count: f?.count ?? 0, limit: f?.limit ?? 0 };
  };
  // 서비스 이용권 확인
  const checkQuota = async () => {
    try {
      const res = await QuotaService.count();
      const value = getValue(res.data);

      setCount(value.count);
      setUserLimit(value.limit);
      setQuotaAccess(value.limit > value.count);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkQuota();
  }, []);

  return (
    <Box gap={24} style={{ paddingTop: '24px' }} id="list-top">
      <Box gap={14} style={{ paddingInline: '16px' }}>
        <Box gap={14} style={{ alignItems: 'flex-start' }}>
          <TitleBox>
            <PageTitle>추천 물건</PageTitle>
          </TitleBox>
          <Text color="#616161" size={14} weight={500}>
            매각기일이 최대 4주 남은 물건들 중 추천해드립니다.
          </Text>
        </Box>
        <Description>
          <Text
            color="#F45551"
            size={13}
            weight={500}
            style={{ textAlign: 'start' }}
          >
            ※ 예상 수익률엔 해당 물건의 모든 리스크가 반영되지 않습니다.
          </Text>
          <Text
            color="#616161"
            size={13}
            weight={500}
            style={{ textAlign: 'start' }}
          >
            투자 전략에 참고용으로 사용하시길 바랍니다.
          </Text>
        </Description>
        <Sub_Description>
          <Text
            size={14}
            weight={500}
            color="#616161"
            style={{ whiteSpace: 'nowrap' }}
          >
            ・ROI : 총 투자비 대비 수익률
          </Text>
          <Text
            size={14}
            weight={500}
            color="#616161"
            style={{ whiteSpace: 'nowrap' }}
          >
            ・ROE : 자기자본 대비 매각수익률
          </Text>
        </Sub_Description>
      </Box>
      <ListTopContainer>
        <TicketCountBadge>
          <Text size={14} weight={500} color="#616161">
            리포트 열람 이용권
          </Text>
          {user?.plan_grade === 'P' ? (
            <Text size={14} weight={700} color="#222222">
              무제한
            </Text>
          ) : (
            <Text size={12} weight={500} color="#37383C9C">
              <Text size={14} weight={700} color="#222222">
                {userLimit - count}
              </Text>
              {` `}/ {userLimit}
            </Text>
          )}
        </TicketCountBadge>
        <FilterDiv>
          <ViewCountButton onClick={() => setOpenViewCountModal(true)}>
            <img src="/assets/images/icon/list.svg" alt="" />
            보기 갯수
          </ViewCountButton>
          <Sort onClick={() => setOepnSortOptionModal(true)}>
            {sortLabelMap[sort]}
            <img src="/assets/images/arrow/arrow-right-darkgray.svg" alt="" />
          </Sort>
        </FilterDiv>
      </ListTopContainer>
      {indexes.length == 0 && (
        <NoThemeDescription>
          한 개 이상의 퀀트 테마를 선택해 주세요
        </NoThemeDescription>
      )}
      {indexes.length > 0 && list.length > 0 && (
        <ItemBox>
          {list.map((item, index) => (
            <Item key={index}>
              <Box gap={8} style={{ alignContent: 'flex-start' }}>
                <BadgeBox>
                  <Category_Badge>
                    <Text size={12} weight={700} color="#FFFFFF">
                      {item.category}
                    </Text>
                  </Category_Badge>
                  <ReportButton
                    disable={item.is_possible === 0 || !quotaAccess}
                    onClick={() => {
                      const grade = user?.plan_grade;
                      if (!grade) {
                        modalDispatch({ type: 'USER_ALERT', payload: 'free' });
                        return;
                      }
                      if (item.is_possible === 0) {
                        modalDispatch({ type: 'USER_ALERT', payload: 'local' });
                        return;
                      }
                      if (!quotaAccess) {
                        if (isFinalMonth(user?.plan_end)) {
                          modalDispatch({
                            type: 'USER_ALERT',
                            payload: 'quotaDepletedExpiring',
                          });
                        } else {
                          modalDispatch({
                            type: 'USER_ALERT',
                            payload: 'quotaDepleted',
                          });
                        }
                        return;
                      }
                      window.open(
                        `/quant/vipreport/${item.quant_idx}/${searchParams.get('indexes')}`,
                        '_blank',
                      );
                      setTimeout(() => {
                        if (grade === 'P') {
                          return;
                        }
                        checkQuota();
                      }, 2000);
                    }}
                  >
                    리포트보기
                  </ReportButton>
                </BadgeBox>
                <Text
                  size={14}
                  weight={700}
                  color="#222222"
                  style={{ textAlign: 'start' }}
                >
                  {item.region}
                </Text>
                <Row gap={4}>
                  {item.tags.map((tag, index) => (
                    <Tag
                      key={index}
                      type={
                        tag.includes('유찰') ? 3 : index === 0 ? item.type : 6
                      }
                    >
                      <span>{tag}</span>
                    </Tag>
                  ))}
                </Row>
              </Box>
              <Divider />

              <Box>
                <TitleBox>
                  <DetailInfoTitle>예상입찰가</DetailInfoTitle>
                  <DetailInfoNumber>
                    {formatKoreanWon(item.ex_bid_prc)}
                  </DetailInfoNumber>
                </TitleBox>
                <TitleBox>
                  <DetailInfoTitle>예상매각가</DetailInfoTitle>
                  <DetailInfoNumber>
                    {' '}
                    {formatKoreanWon(item.ex_sale_prc)}
                  </DetailInfoNumber>
                </TitleBox>
                <TitleBox>
                  <DetailInfoTitle>예상매매차익</DetailInfoTitle>
                  <DetailInfoNumber color="#F45551">
                    {formatKoreanWon(item.margin)}
                  </DetailInfoNumber>
                </TitleBox>
              </Box>
              <Divider />

              <Row02 gap={16}>
                <Text size={14} weight={500} color="#616161">
                  ROI:{' '}
                  <Text size={14} weight={700} color="#008AFF">
                    {item.roi ? item.roi : '-'}%
                  </Text>
                </Text>
                <Text size={14} weight={500} color="#616161">
                  ROE:{' '}
                  <Text size={14} weight={700} color="#008AFF">
                    {item.roe ? item.roe : '-'}%
                  </Text>
                </Text>
              </Row02>
              <Divider />

              {selectedThemes.slice(0, 2).map((theme, idx) => {
                const key = themeMap[theme.name];
                if (!key) return null;

                const titleMap: Partial<Record<string, string>> = {
                  appraisal_vs_market_price: '시세 대비 감정가',
                  bid_vs_public_land_price: '공시지가 대비 입찰가',
                  lowest_bid_vs_jeonse: '전세가 대비 최저입찰가',
                  jeonse_advantage_3y: '최근 6개월 전세 우위 비중',
                  wolse_advantage_3y: '최근 6개월 월세 우위 비중',
                  nearby_avg_vs_market_price: '인근 평균 시세 대비',
                  sale_price_vs_lowest_bid: '최저입찰가 대비 매각가',
                  expected_equity: '예상 자기자본',
                  real_trade_growth_rate_1y: '최근 1년 실거래 상승율',
                  monthly_rent_vs_loan_interest: '대출이자 대비 월세 수익률',
                };
                function formatPercentage(value: number) {
                  if (value === null || value === undefined || isNaN(value))
                    return '-';
                  return `${value}%`;
                }
                const detailLabelMap: Record<
                  string,
                  {
                    label1: string;
                    label2: string;
                    diffPrefix: string;
                  }
                > = {
                  appraisal_vs_market_price: {
                    label1: 'AI 추정가',
                    label2: '감정가',
                    diffPrefix: '시세보다 감정가가',
                  },
                  bid_vs_public_land_price: {
                    label1: '공시지가',
                    label2: '최저입찰가',
                    diffPrefix: '공시지가보다 매입가가',
                  },
                  lowest_bid_vs_jeonse: {
                    label1: '전세보증금',
                    label2: '최저입찰가',
                    diffPrefix: '전세가보다 최저입찰가가',
                  },
                  sale_price_vs_lowest_bid: {
                    label1: '최저입찰가',
                    label2: '매각가',
                    diffPrefix: '최저입찰가보다 매각가가',
                  },
                  jeonse_advantage_3y: {
                    label1: '월세 우위 비중',
                    label2: '전세 우위 비중',
                    diffPrefix: '최근 3년 월세보다 전세비중이',
                  },
                  wolse_advantage_3y: {
                    label1: '전세 우위 비중',
                    label2: '월세 우위 비중',
                    diffPrefix: '최근 3년 전세보다 월세비중이',
                  },
                  nearby_avg_vs_market_price: {
                    label1: '인근지역 평균시세',
                    label2: '최저입찰가',
                    diffPrefix: '인근지역 평균 시세보다 최저입찰가가',
                  },
                  expected_equity: {
                    label1: '',
                    label2: '',
                    diffPrefix: '예상자기 자본',
                  },
                  real_trade_growth_rate_1y: {
                    label1: '',
                    label2: '',
                    diffPrefix: '최근 6개월 실거래 상승률',
                  },
                  monthly_rent_vs_loan_interest: {
                    label1: '월 대출이자',
                    label2: '월세수익',
                    diffPrefix: '월 대출이자보다 월세수익이',
                  },
                };

                const labels = detailLabelMap[key];
                // 비교 값 추출 유틸 함수
                const getCompareValues = (key: string, item: any) => {
                  switch (key) {
                    case 'appraisal_vs_market_price':
                      return {
                        label1Value: item?.ex_sale_prc,
                        label2Value: item?.appraise_prc,
                      };
                    case 'bid_vs_public_land_price':
                      return {
                        label1Value: item?.official_prc,
                        label2Value: item?.min_prc,
                      };
                    case 'lowest_bid_vs_jeonse':
                      return {
                        label1Value: item?.jeonse,
                        label2Value: item?.min_prc,
                      };
                    case 'sale_price_vs_lowest_bid':
                      return {
                        label1Value: item?.min_prc,
                        label2Value: item?.ex_sale_prc,
                      };
                    case 'jeonse_advantage_3y':
                      return {
                        label1Value: item?.wolse_advantage_3y ?? 0,
                        label2Value: item?.jeonse_advantage_3y ?? 0,
                      };
                    case 'wolse_advantage_3y':
                      return {
                        label1Value: item?.jeonse_advantage_3y ?? 0,
                        label2Value: item?.wolse_advantage_3y ?? 0,
                      };
                    case 'expected_equity':
                      return {
                        label1Value: null,
                        label2Value: item?.investment,
                      };
                    case 'nearby_avg_vs_market_price':
                      return {
                        label1Value: item?.surrounding_prc ?? 0,
                        label2Value: item?.min_prc ?? 0,
                      };
                    case 'real_trade_growth_rate_1y':
                      return {
                        label1Value: null,
                        label2Value: item?.real_trade_growth_rate_1y,
                      };
                    case 'monthly_rent_vs_loan_interest':
                      return {
                        label1Value: item?.wolse_interest,
                        label2Value: item?.wolse_profit,
                      };
                    default:
                      return {
                        label1Value: null,
                        label2Value: null,
                      };
                  }
                };

                const { label1Value, label2Value } = getCompareValues(
                  key,
                  item,
                );

                const diff =
                  label1Value !== null && label2Value !== null
                    ? label2Value - label1Value
                    : null;

                if (key === 'expected_equity') {
                  return (
                    <Row03 key={`${idx}-expected-equity`}>
                      <div>
                        <DetailInfoTitle>
                          {labels?.diffPrefix ?? '예상 자기자본'}
                        </DetailInfoTitle>
                        <DetailInfoNumber>
                          {label2Value !== null && label2Value !== undefined
                            ? formatKoreanWon(label2Value)
                            : '-'}
                        </DetailInfoNumber>
                      </div>
                    </Row03>
                  );
                }

                if (key === 'real_trade_growth_rate_1y') {
                  const textColor =
                    label2Value === null || label2Value === undefined
                      ? '#222'
                      : label2Value > 0
                        ? '#F45551' // 상승
                        : '#222'; // 0인 경우
                  return (
                    <Row03 key={`${idx}-real-trade-growth-6m`}>
                      <div>
                        <DetailInfoTitle>
                          {labels?.diffPrefix ?? '최근 6개월 실거래 상승률'}
                        </DetailInfoTitle>
                        <DetailInfoNumber color={textColor}>
                          {label2Value !== null && label2Value !== undefined
                            ? formatPercentage(label2Value)
                            : '-'}{' '}
                          <img
                            src="/assets/images/arrow/arrow-up-red-fill.svg"
                            alt=""
                          />
                        </DetailInfoNumber>
                      </div>
                    </Row03>
                  );
                }

                return (
                  <>
                    <Row key={idx} style={{ justifyContent: 'space-between' }}>
                      <Row03>
                        <div>
                          <DetailInfoTitle>
                            {labels?.label1 ??
                              renderDetailTitle(titleMap[key] ?? '')}
                          </DetailInfoTitle>
                          <DetailInfoNumber color="#222">
                            {label1Value !== null && label1Value !== undefined
                              ? key === 'jeonse_advantage_3y' ||
                                key === 'wolse_advantage_3y'
                                ? formatPercentage(label1Value)
                                : formatKoreanWon(label1Value)
                              : '-'}
                          </DetailInfoNumber>
                        </div>
                        <div>
                          <DetailInfoTitle>
                            {labels?.label2 ??
                              renderDetailTitle(titleMap[key] ?? '')}
                          </DetailInfoTitle>
                          <DetailInfoNumber color="#222">
                            {label2Value !== null && label2Value !== undefined
                              ? key === 'jeonse_advantage_3y' ||
                                key === 'wolse_advantage_3y'
                                ? formatPercentage(label2Value)
                                : formatKoreanWon(label2Value)
                              : '-'}
                          </DetailInfoNumber>
                        </div>
                      </Row03>
                    </Row>
                    <Row04 key={`${idx}-diff`}>
                      <DetailInfoTitle>
                        {labels?.diffPrefix ?? ''}
                      </DetailInfoTitle>
                      <DetailInfoNumber02>
                        {label1Value !== null && label2Value !== null ? (
                          <>
                            {key === 'jeonse_advantage_3y' ||
                            key === 'wolse_advantage_3y'
                              ? `${Math.abs(diff!)}%`
                              : formatKoreanWon(Math.abs(diff!))}{' '}
                            <span
                              style={{
                                color: diff! > 0 ? '#F45551' : '#008AFF',
                              }}
                            >
                              {diff! > 0 ? '높음' : '낮음'}
                            </span>
                          </>
                        ) : (
                          '-'
                        )}
                      </DetailInfoNumber02>
                    </Row04>
                  </>
                );
              })}

              {selectedThemes.length > 2 && (
                <MoreButton
                  onClick={() => {
                    setSelectedItem(item);
                    setOpenDetailInfoModal(true);
                  }}
                >
                  더보기 <img src="/assets/images/arrow/arrow-down-gray.svg" />
                </MoreButton>
              )}
            </Item>
          ))}
        </ItemBox>
      )}
      {indexes.length > 0 && list.length > 0 && (
        <Box style={{ padding: '0 16px 72px' }}>
          <Pagination
            currentPage={cuurentPage}
            totalPages={Math.ceil(totalCount / limit)}
            onPageChange={(page) => {
              if (selectedRegions.length === 0) {
                const grade = user?.plan_grade;
                if (!grade) {
                  modalDispatch({ type: 'USER_ALERT', payload: 'free' });
                  return;
                } else if (!user?.plan_region?.includes('A')) {
                  modalDispatch({ type: 'USER_ALERT', payload: 'local' });
                  return;
                }
              }
              setCurrentPage(page);
            }}
            removeMargin={true}
            disabled={
              selectedRegions.length === 0 &&
              (!user?.plan_grade || !user?.plan_region?.includes('A'))
            }
          />
        </Box>
      )}
      {indexes.length > 0 && list.length === 0 && (
        <BlinkBox>현재 추천 가능한 물건이 없습니다.</BlinkBox>
      )}
      {/* {openReportModal && (
        <ReportModal
          isFinal={isFinal}
          periodEnd={periodEnd}
          onClose={() => {
            setOpenReportModal(false);
          }}
        />
      )} */}
      {openModal && (
        <ThemeModal
          onClose={() => setOpenModal(false)}
          search_category={selectedTheme}
        />
      )}
      {openDetailInfoModal && selectedItem && (
        <DetailInfoModal
          item={selectedItem} // QuantReportItem
          selectedThemes={selectedThemes.map((t) => t.name)}
          onClose={() => {
            setOpenDetailInfoModal(false);
          }}
        />
      )}
      {openViewCountModal && (
        <ViewCountModal
          onClose={() => setOpenViewCountModal(false)}
          limit={limit}
          setLimit={setLimit}
        />
      )}
      {oepnSortOptionModal && (
        <SortOptionModal
          onClose={() => setOepnSortOptionModal(false)}
          sort={sort}
          setSort={setSort}
        />
      )}
    </Box>
  );
};

export default Quant3;

const R_Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
`;

const BtnRP = styled.button<{ disable: boolean }>`
  border: none;
  background: #70737c14;
  width: 100%;
  border-radius: 8px;
  padding-top: 9px;
  padding-right: 16px;
  padding-bottom: 9px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: ${({ disable }) => (disable ? 'default' : 'pointer')};
  opacity: ${({ disable }) => disable && 0.4};

  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * 0.02);
    color: #616161;
    width: 100%;
    text-align: center;
  }
`;

const BlinkBox = styled.div`
  width: 100%;
  height: 188px;
  gap: 16px;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Category_Badge = styled.div<{ type?: number }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
  background: #008aff;
  border: 1px solid #008aff;
  width: fit-content;
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0 16px 16px;
`;

const Tag = styled.span<{ type: number }>`
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
  padding-left: 5px;
  background: ${(props) => {
    switch (props.type) {
      case 1:
        return '#E6F4FF';
      case 2:
        return '#F1FCF8';
      case 3:
        return '#FCF5F1';
      case 4:
        return '#F1EEFF';
      case 5:
        return '#FEEFF4';
      default:
        return '#70737C14';
    }
  }};
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: calc(12px * -0.05);
    color: ${(props) => {
      switch (props.type) {
        case 1:
          return '#008AFF';
        case 2:
          return '#27A131';
        case 3:
          return '#EC5717';
        case 4:
          return '#836BF1';
        case 5:
          return '#F45551';
        default:
          return '#37383C9C';
      }
    }};
  }
`;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;
const Row02 = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
  justify-content: end;
`;
const Row03 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
`;
const Row04 = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #f7f8fc;
`;

const TitleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  color: #171e26;
`;

const Description = styled(Box)`
  width: 100%;
  gap: 8px;
  border-radius: 16px;
  background: #fff8f8;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
`;

const Sub_Description = styled(Box)`
  gap: 4px;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 12px;
  padding-left: 16px;
  border-radius: 8px;
  background: #70737c0d;
  width: 100%;
  align-items: flex-start;
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  text-align: center;
  color: ${(props) => props.color};
`;

const Item = styled.button`
  width: 100%;
  border-radius: 16px;
  padding: 16px;
  gap: 12px;
  border: 1px solid #e5e8ea;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  :hover {
  }
  cursor: pointer;
`;

const NoThemeDescription = styled.div`
  text-align: center;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 144px;
  padding-left: 16px;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const BadgeBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ReportButton = styled.button<{ disable: boolean }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #008aff;
  cursor: ${({ disable }) => (disable ? 'default' : 'pointer')};
  opacity: ${({ disable }) => disable && 0.4};
  border: none;
  background-color: transparent;
`;

const ThemeBadge = styled(Category_Badge)<{ hasPopover: boolean }>`
  background: #d224ca;
  border: none;
  cursor: ${(props) => (props.hasPopover ? 'pointer' : 'default')};
`;

const TicketCountBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e8ea;
`;

const DetailInfoTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  justify-content: center;
  span {
    font-weight: 700;
    color: #222;
  }
`;

const DetailInfoNumber = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ color }) => (color ? color : '#222')};
  justify-content: center;
`;
const DetailInfoNumber02 = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ color }) => (color ? color : '#222')};
`;
const MoreButton = styled.div`
  position: relative;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  background-color: transparent;

  font-weight: 500;
  font-size: 12px;
  line-height: 40px;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 16px;
    height: 16px;
  }
`;
const PopoverBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff;
  box-shadow: 0px 4px 15px 0px #8d95a340;
  border-radius: 24px;
  padding: 8px 0;
  z-index: 10;
  width: 100%;
  border: 1px solid #e1e2e4;
  box-shadow:
    0px 0px 1px 0px #00000014,
    0px 1px 4px 0px #00000014,
    0px 2px 8px 0px #0000001f;
  cursor: default;
`;

const PopoverHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #222;
  img {
    background: none;
    border: none;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
  }
`;
const PopoverContent = styled.div`
  width: 100%;
  padding: 8px 16px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ListTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding-inline: 16px;
`;

const FilterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const ViewCountButton = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  background: rgba(112, 115, 124, 0.05);

  color: #4e5968;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const Sort = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: var(--semantic-label-neutral, #616161);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;

  & > img {
    transform: rotate(90deg);
  }
`;
